import { useTRPC } from "../../../../trpc/client";
import { useMutation } from "@tanstack/react-query";

export function useEditCreateCustomer(
  onSuccessCallback: () => void,
  onErrorCallback: (error: unknown) => void
) {
  const trpc = useTRPC();
  const mutation = useMutation(trpc.customers.create.mutationOptions());

  return async (data: Parameters<typeof mutation.mutateAsync>[0]) => {
    try {
      await mutation.mutateAsync(data);
      onSuccessCallback();
    } catch (error) {
      console.error("Customer creation error:", error);
      onErrorCallback(error);
    }
  };
}
